import {observer} from "mobx-react-lite";
import Btn from "../../ui/Btn";
import appStore from "../../storage/AppStore";
import {addMonths, endOfMonth, monthLabel, startOfMonth} from "../../common/utils";
import Select from "../../ui/Select";
import {useEffect, useMemo, useState} from "react";

const GamesFilter = ({store}) => {
  const [tournaments, setTournaments] = useState([]);

  const getInitialMonth = () => {
    const from = store?.gamesQuery?.date_from;
    return from ? startOfMonth(new Date(from)) : startOfMonth(new Date());
  };

  const [month, setMonth] = useState(getInitialMonth);

  const isNextDisabled = useMemo(() => {
    const next = addMonths(month, 1);
    return startOfMonth(next) > startOfMonth(new Date());
  }, [month]);

  const applyMonthToQuery = (m) => {
    const from = startOfMonth(m);
    let to = endOfMonth(m);
    const now = new Date();

    const isCurrentMonth =
      from.getFullYear() === now.getFullYear() &&
      from.getMonth() === now.getMonth();

    if (isCurrentMonth) to = null;

    store.gamesQuery.setProperty("date_from", from);
    store.gamesQuery.setProperty("date_to", to);
  };

  const goPrev = () => {
    const m = addMonths(month, -1);
    setMonth(m);
    applyMonthToQuery(m);
    store.searchGames();
  };

  const goNext = () => {
    if (isNextDisabled) return;
    const m = addMonths(month, 1);
    setMonth(m);
    applyMonthToQuery(m);
    store.searchGames();
  };

  const goCurrent = () => {
    const m = startOfMonth(new Date());
    setMonth(m);
    applyMonthToQuery(m);
    store.searchGames();
  };

  useEffect(() => {
    store.searchTournamentsForFilter().then((tt) => setTournaments(tt || []));
  }, []);

  return (
    <div className="col-12 competition-filter">
      <div className="competition-filter__panel">
        <div className="competition-filter__month-row">
          <div className="competition-filter__calendar" aria-hidden="true">
            <i className="pi pi-calendar"/>
          </div>
          <div className="competition-filter__month-nav">
            <Btn icon="pi pi-angle-left" severity="secondary" outlined
                 className="competition-filter__arrow" onClick={goPrev}/>
            <Btn label={monthLabel(month, appStore.tr)} severity="secondary"
                 className="competition-filter__month-button" onClick={goCurrent}/>
            <Btn icon="pi pi-angle-right" severity="secondary" outlined
                 className="competition-filter__arrow" onClick={goNext} disabled={isNextDisabled}/>
          </div>
        </div>

        <div className="competition-filter__controls">
          <div className="competition-filter__select">
            <Select store={store.gamesQuery} prop="tournament_id" options={tournaments}
                    id="input_child" label={appStore.tr.tournament} for_search/>
          </div>
          <div className="competition-filter__action">
            <Btn icon="pi pi-search" label={appStore.tr.search}
                 className="competition-filter__search-button" onClick={() => store.searchGames()}/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(GamesFilter);
